import React, { PureComponent } from 'react';

class Spinner extends PureComponent {
    render() {
        return (
            <img
                {...this.props}
                src="//static.finncdn.no/bb/latest/css/spaden/img/loading/spinner-blue.svg"
            />
        );
    }
}

export default Spinner;
